import ascSort from 'utils/ascSort'

function parseTerms(terms): Term[] {
  return Object.keys(terms)
    .sort((a, b) => ascSort(terms[a].order, terms[b].order))
    .map(key => {
      const term = terms[key]
      return { text: term.details.html, category: term.category }
    })
}

export default parseTerms
